import Ratings from "react-ratings-declarative";
import { useLocation, Link, useParams, useHistory } from "react-router-dom";
import { useCart } from "../CartContext";
import { STAR_ICON_PATH } from "../constants/icons";
import { useEffect } from "react";
import { PRD_LIST } from "../../data/products";

function ProductDetail() {
  const { addToCart } = useCart();
  const location = useLocation();
  const { id } = useParams();
  const history = useHistory();

  const state = location.state || {};
  const product = PRD_LIST.find((p) => p.id === Number(id)) || null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!product) {
    console.warn("Product not found for id:", id);
    return <div className="container mt-5">Product not found.</div>;
  }

  const related = PRD_LIST
    .filter((p) => p.category === product.category && p.id !== product.id)
    .slice(0, 4);

  console.log("ProductDetail -> product:", product);
  console.log("ProductDetail -> related:", related);

  function changeRating() {}

  const handleAddToCart = () => {
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      quantity: 1,
    });
  };

  return (
    <div className="container mt-5 py-4 px-xl-5">
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb" className="bg-custom-light rounded mb-4">
        <ol className="breadcrumb p-3">
          <li className="breadcrumb-item">
            <Link to="/products" className="text-decoration-none link-secondary">
              All Products
            </Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {product.name}
          </li>
        </ol>
      </nav>

      {/* Product detail */}
      <div className="row mb-4">
        <div className="col-lg-6">
          <img
            className="border rounded w-100"
            alt={product.name}
            src={state.image || product.image}
          />
        </div>

        <div className="col-lg-6">
          <h2>{product.name}</h2>
          <h4 className="text-muted mb-4">{product.price} Đ</h4>

          <div className="row g-3 mb-4">
            <div className="col">
              <button className="btn btn-outline-dark w-100" onClick={handleAddToCart}>
                Add to cart
              </button>
            </div>
            <div className="col">
              <button
                className="btn btn-dark w-100"
                onClick={() => history.push("/checkout")}
              >
                Buy now
              </button>
            </div>
          </div>

          <h4 className="mb-0">Details</h4>
          <hr />
          <dl className="row">
            <dt className="col-sm-4">Code</dt>
            <dd className="col-sm-8 mb-3">C000{product.id}</dd>
            <dt className="col-sm-4">Brand</dt>
            <dd className="col-sm-8 mb-3">{product.name}</dd>
            <dt className="col-sm-4">Status</dt>
            <dd className="col-sm-8 mb-3">Instock</dd>
            <dt className="col-sm-4">Price</dt>
            <dd className="col-sm-8 mb-3">{product.price}</dd>
            <dt className="col-sm-4">Rating</dt>
            <dd className="col-sm-8 mb-3">
              <Ratings
                rating={4.5}
                widgetRatedColors="rgb(253, 204, 13)"
                changeRating={changeRating}
                widgetSpacings="2px"
              >
                {Array.from({ length: 5 }, (_, i) => (
                  <Ratings.Widget
                    key={i}
                    widgetDimension="20px"
                    svgIconViewBox="0 0 19 20"
                    svgIconPath={STAR_ICON_PATH}
                    widgetHoverColor="rgb(253, 204, 13)"
                  />
                ))}
              </Ratings>
            </dd>
          </dl>
        </div>
      </div>

      {/* Related products */}
      <div className="row">
        <div className="col-md-12 mb-4">
          <hr />
          <h4 className="text-muted my-4">Related products</h4>
          {related.length === 0 ? (
            <p>No related products found.</p>
          ) : (
            <div className="row row-cols-1 row-cols-md-3 row-cols-lg-4 g-3">
              {related.map((item) => (
                <div
                  className={`col ${
                    item.id === Number(id) ? "border border-primary rounded p-2" : ""
                  }`}
                  key={item.id}
                >
                  <Link
                    to={{
                      pathname: `/products/${item.id}`,
                      state: { image: item.image },
                    }}
                    className="text-decoration-none"
                  >
                    <img
                      className="rounded mb-2 w-100"
                      alt={item.name}
                      src={item.image}
                    />
                    <div className="small">{item.name}</div>
                    <div className="text-muted">{item.price} Đ</div>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;
